import { useEffect } from 'react';
import { X, Bell, CircleAlert, CircleCheckBig } from 'lucide-react';
import useUIStore from '../store/useUIStore';

export default function ToastContainer() {
  const { toasts, removeToast } = useUIStore();

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 pointer-events-none">
      {toasts.map((toast) => (
        <ToastItem key={toast.toastId} toast={toast} onRemove={() => removeToast(toast.toastId)} />
      ))}
    </div>
  );
}

function ToastItem({ toast, onRemove }) {
  const tone = toast.type || 'info';

  useEffect(() => {
    const timer = setTimeout(() => {
      onRemove();
    }, 5000); // Auto-dismiss after 5 seconds
    return () => clearTimeout(timer);
  }, [onRemove]);

  const toneConfig =
    tone === 'success'
      ? {
          icon: CircleCheckBig,
          accentClass: 'bg-green-100 text-green-700 dark:bg-green-500/10 dark:text-green-300',
          linkClass:
            'text-green-700 hover:text-green-800 dark:text-green-300 dark:hover:text-green-200',
        }
      : tone === 'error'
        ? {
            icon: CircleAlert,
            accentClass: 'bg-red-100 text-red-700 dark:bg-red-500/10 dark:text-red-300',
            linkClass: 'text-red-700 hover:text-red-800 dark:text-red-300 dark:hover:text-red-200',
          }
        : {
            icon: Bell,
            accentClass: 'bg-primary/10 text-primary',
            linkClass: 'text-primary hover:text-primary/80',
          };

  const Icon = toneConfig.icon;

  return (
    <div className="pointer-events-auto w-80 bg-card rounded-xl shadow-lg border border-border overflow-hidden flex items-start animate-in slide-in-from-right-5 fade-in duration-300">
      <div
        className={`flex items-center justify-center border-r border-border p-3 ${toneConfig.accentClass}`}
      >
        <Icon className="w-5 h-5" />
      </div>
      <div className="p-3 flex-1 min-w-0">
        <p className="text-sm text-foreground font-medium wrap-break-words">{toast.message}</p>
        {toast.linkUrl && (
          <a
            href={toast.linkUrl}
            className={`mt-1 inline-block text-xs font-semibold ${toneConfig.linkClass}`}
            onClick={onRemove}
          >
            View Details &rarr;
          </a>
        )}
      </div>
      <button
        onClick={onRemove}
        className="p-3 text-muted-foreground hover:text-foreground hover:bg-accent transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
